/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
import { createSlice } from "@reduxjs/toolkit";

import { FeatureFlagState } from "~/features/featureFlag/types";
import initFeatureFlags from "~/features/featureFlag/utils/initFeatureFlags";

const initialState: FeatureFlagState = {
  flags: initFeatureFlags(location.search),
};

const featureFlagSlice = createSlice({
  name: "featureFlag",
  initialState,
  reducers: {},
});

export const featureFlagReducer = featureFlagSlice.reducer;
